import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Space, Typography, Form, Input, Button, Select, Table, AutoComplete, message } from 'antd'
import { withRouter } from 'react-router'
import { reqSearchSite } from '../../api'

const { Paragraph } = Typography
const { Option } = Select

class SearchSite extends React.Component {
    state = {
        searchResult: ''
    }

    async componentDidMount() {
        let searchResult = ''
        let searchValue = this.props.match.params.value
        const param = {
            text: searchValue
        }
        const result = await reqSearchSite(param)
        if (result.code === 0) {
            searchResult = result.data.results
        } else {
            message.error('Request failed.')
        }

        this.setState({
            searchResult: searchResult
        })
    }

    render() {
        return (<></>)
    }
}

export default withRouter(SearchSite)
